import React, { useContext } from "react";
import PI from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useTranslation } from "react-i18next";
import { validatePhoneNumber } from "../helpers/CommonUtility";
import themeContext from "../context/theme/ThemeContext";
const ReactPhoneInput = PI.default ? PI.default : PI;

const labelStyle = {
  marginTop: "8px",
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "2px",
  display: "block",
};

const MobileInput = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const [t] = useTranslation();
  return (
    <>
      <span style={labelStyle}>{props.label}</span>
      <ReactPhoneInput
        country={"in"}
        name={props.name}
        countryCodeEditable={false}
        value={props.value}
        placeholder="Mobile"
        specialLabel=""
        dropdownStyle={{
          backgroundColor: getThemeColor("action-details-background"),
          color: getThemeColor("primary-color"),
        }}
        inputStyle={{
          backgroundColor: "transparent",
          width: "100%",
          borderRadius: "5px",
          border: "none",
          height: "30px",
          color: getThemeColor("primary-color"),
          border: "1px solid rgb(191, 191, 191)",
          borderRadius: "7px"
        }}
        onChange={props.onChangeCustom}
        isValid={(inputNumber, country) => {
           let targetLength = country.format.match(/\./g).length;
           let fixedLength = targetLength - country.dialCode.length;
           let inputTargetLength =
             inputNumber.length - country.countryCode.length;
          // //console.log("--- Country code ----",country,targetLength,country.dialCode.length);
          // if (
          //   inputTargetLength != fixedLength &&
          //   inputNumber.length > country.dialCode.length &&
          //   !(inputNumber.length >= 10 && fixedLength > 10)
          // ) {
            
          //   return (
          //     "For " + country.name + " (" + fixedLength + " digits required)"
          //   );
          // }
          if (
            (inputTargetLength == 0 || inputNumber.length < 2 ) && props.touched===true
          ) {
            
            return (
              "Mobile cannot be blank"
            );
          }
          return validatePhoneNumber(inputNumber, country, t);
        }}
      />
    </>
  );
};

export default MobileInput;
